<template>
  <ContentSection :spacing="spacing">
    <Container :indent="indent">
      <h2
        v-if="data.heading"
        class="mb-5 text-xl font-medium sm:mb-6 md:text-2xl"
        v-html="data.heading"
      />

      <AnimatedContainer>
        <ul class="flex flex-col space-y-3 xl:max-w-[66vw]">
          <li
            v-for="(file, index) in (!data.select_manually && data.files) ||
            data.manually_selected_files"
            :key="index"
            class="fade-in"
          >
            <FileItem :data="file" :name="file.name" />
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
  prevComponent: { type: String, default: null },
  nextComponent: { type: String, default: null },
})
const isJob = inject('isJob', null)
const isNewsArticle = inject('isNewsArticle', null)
const isCourtDecision = inject('isCourtDecision', null)
const isSustainabilityArticle = inject('isSustainabilityArticle', null)
const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent
)

const spacing = computed(() => {
  if (isJob || isCourtDecision) {
    return 'none'
  }
  if (isNewsArticle || isSustainabilityArticleWithSidebar) {
    return 'sm-margin'
  }
  return conditionalSpacing.value
})

const indent = computed(() => {
  if (isJob || isCourtDecision) {
    return 'wide'
  }
  if (isNewsArticle || isSustainabilityArticleWithSidebar) {
    return 'none'
  }
  if (isSustainabilityArticle) {
    return 'default'
  }
  return 'center'
})
</script>
